import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0022_BMCU_CAN57 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0022_BMCU_CAN57',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageInternalVoltage',
              isRead: 'true',
              interval: '441',
              texttableentry: 'ElectricalEnergyStorageInternalVoltage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageExternalVoltage',
              isRead: 'true',
              interval: '443',
              texttableentry: 'ElectricalEnergyStorageExternalVoltage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageElectricCurrent',
              isRead: 'true',
              interval: '445',
              texttableentry: 'ElectricalEnergyStorageElectricCurrent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageElectricCurrentReference',
              isRead: 'true',
              interval: '447',
              texttableentry: 'ElectricalEnergyStorageElectricCurrentReference',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrechargeRelais',
              isRead: 'true',
              interval: '453',
              texttableentry: 'PrechargeRelais',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MainPowerRelais',
              isRead: 'true',
              interval: '455',
              texttableentry: 'MainPowerRelais',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSensorMinMaxAverageStatistics',
              isRead: 'true',
              interval: '569',
              texttableentry: 'ResetSensorMinMaxAverageStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumberCascadeSystemOne',
              isRead: 'true',
              interval: '1134',
              texttableentry: 'ViessmannIdentificationNumberCascadeSystemOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageOperationState',
              isRead: 'true',
              interval: '1552',
              texttableentry: 'ElectricalEnergyStorageOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOneOperatingData',
              isRead: 'true',
              interval: '1577',
              texttableentry: 'ElectricalEnergyStorageModuleOneOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleTwoOperatingData',
              isRead: 'true',
              interval: '1578',
              texttableentry: 'ElectricalEnergyStorageModuleTwoOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleThreeOperatingData',
              isRead: 'true',
              interval: '1579',
              texttableentry: 'ElectricalEnergyStorageModuleThreeOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFourOperatingData',
              isRead: 'true',
              interval: '1580',
              texttableentry: 'ElectricalEnergyStorageModuleFourOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFiveOperatingData',
              isRead: 'true',
              interval: '1581',
              texttableentry: 'ElectricalEnergyStorageModuleFiveOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSixOperatingData',
              isRead: 'true',
              interval: '1582',
              texttableentry: 'ElectricalEnergyStorageModuleSixOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfCharge',
              isRead: 'true',
              interval: '1664',
              texttableentry: 'ElectricalEnergyStorageStateOfCharge',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FunctionalSoftwareVersion',
              isRead: 'true',
              interval: '1710',
              texttableentry: 'FunctionalSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceProcessValues',
              isRead: 'true',
              interval: '1803',
              texttableentry: 'DebuggingInterfaceProcessValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfacePowerDemand',
              isRead: 'false',
              interval: '1804',
              texttableentry: 'DebuggingInterfacePowerDemand',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceProgrammingMode',
              isRead: 'true',
              interval: '1805',
              texttableentry: 'DebuggingInterfaceProgrammingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DebuggingInterfaceReleaseCheckTestFunctions',
              isRead: 'false',
              interval: '1806',
              texttableentry: 'DebuggingInterfaceReleaseCheckTestFunctions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfEnergy',
              isRead: 'true',
              interval: '1834',
              texttableentry: 'ElectricalEnergyStorageStateOfEnergy',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_NoDescription',
              isRead: 'true',
              interval: '2329',
              texttableentry: 'BatteryEnergyUsedAverage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryModuleCellType',
              isRead: 'true',
              interval: '2988',
              texttableentry: 'ElectricalEnergySystemBatteryModuleCellType',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryModuleCount',
              isRead: 'true',
              interval: '2989',
              texttableentry: 'ElectricalEnergySystemBatteryModuleCount',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryCapacityDelta',
              isRead: 'true',
              interval: '2990',
              texttableentry: 'ElectricalEnergySystemBatteryCapacityDelta',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryCapacity',
              isRead: 'true',
              interval: '2991',
              texttableentry: 'ElectricalEnergySystemBatteryCapacity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemStateOfChargeUseable',
              isRead: 'true',
              interval: '2992',
              texttableentry: 'ElectricalEnergySystemStateOfChargeUseable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ArrayLastFiveEstimatedValuesOfUsableSystemEnergy',
              isRead: 'true',
              interval: '2993',
              texttableentry: 'ArrayLastFiveEstimatedValuesOfUsableSystemEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryLastForcedBalancingTime',
              isRead: 'true',
              interval: '2994',
              texttableentry: 'ElectricalEnergySystemBatteryLastForcedBalancingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemBatteryLastForcedCalibrationTime',
              isRead: 'true',
              interval: '2995',
              texttableentry: 'ElectricalEnergySystemBatteryLastForcedCalibrationTime',
              isWrite: 'true',
            },
          ],
        },
      ],
    };
  }
}
